import React from 'react'
import TextField from 'components/TextField'
import FormSection from 'components/FormSection'
import MultiFieldsGroup from 'components/MultiFieldsGroup'
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import AutoSuggestionInput from 'components/AutoSuggestionInput'
import { hobbies } from 'suggestions'
import InputLabel from '@material-ui/core/InputLabel';


const Links = ({
  mutators
}) => (
  <FormSection
    title={(
      <Typography variant="h6" component="h2">
      Hobby 
      </Typography> 
    )}
  > 
    <MultiFieldsGroup
      name='hobby'
      mutators={mutators}
      label='hobby'
      fieldToPreview='title'
      renderFieldsGroup={(name, index) => ( 
        <>       
        <InputLabel shrink>
        Hobby
        </InputLabel>
        <AutoSuggestionInput
          name={`${name}.title`}
          type="text"
          suggestions={hobbies}
        />
        </>
      )}
    />
  </FormSection>
)

export default Links